<div class="h-full flex flex-col">
  <div>
    <prox-breadcrumb></prox-breadcrumb>
  </div>
  <div class="flex grow mt-3">
    <div *ngIf="items.length" class="sidebar-wrapper">
      <div class="sidebar-container">
        <!-- Accordion, matching its three sibling manager menus. -->
        <p-panelMenu styleClass="layout-submenu" [model]="items" [multiple]="false"></p-panelMenu>
      </div>
    </div>
    <div class="grow flex flex-col qb-manager-content items-center justify-center text-center p-8">
      <div class="max-w-xl">
        <i class="fa-solid fa-lock text-amber-600 text-6xl mb-4"></i>
        <h2 class="text-2xl font-bold mb-2">Account Locked for Training</h2>
        <p class="text-base text-gray-700 mb-2">
          Your account administration menus are currently locked.
        </p>
        <p class="text-base text-gray-700">
          Account changes are made during a supervised training session with your Proximity Training Specialists.
          Please contact your supplier to unlock the account.
        </p>
      </div>
    </div>
  </div>
</div>